import React from 'react';

const SvgBackButton: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 45" {...props}>
      <defs>
        <filter
          id="backButton_svg__a"
          x={0}
          y={0}
          width={40}
          height={45}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx={5} dy={5} />
          <feGaussianBlur result="b" />
          <feFlood floodOpacity={0.161} />
          <feComposite operator="in" in2="b" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g filter="url(#backButton_svg__a)">
        <path d="M9.117 25.209a6 6 0 010-10.419l16.906-9.66A6 6 0 0135 10.339v19.322a6 6 0 01-8.977 5.209z" />
      </g>
    </svg>
  );
};

export default SvgBackButton;
